import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { valueHasChanged } from '@nstep-common/utils';
import { merge } from 'lodash';

@Component({
	selector: 'sm-calendar',
	template: '<ng-content></ng-content>',
	standalone: false
})
export class CalendarComponent implements AfterViewInit, OnDestroy, OnChanges {
	jQueryElement: any;
	@Input() settings: any = {};

	@Input() value: Date | null = null;
	@Output() valueChange = new EventEmitter<Date | null>();

	@Input() minValue: Date | null = null;
	@Input() maxValue: Date | null = null;

	minDate: Date | null = null;
	maxDate: Date | null = null;

	constructor(private elementRef: ElementRef) {
	}

	ngAfterViewInit(): void {
		if (this.jQueryElement) {
			return;
		}

		const settings = merge({
			onShow: () => {
				if (this.getMinDate()) {
					this.jQueryElement
						.calendar('setting', 'minDate', this.getMinDate())
						.calendar('refresh');
				}

				if (this.getMaxDate()) {
					this.jQueryElement
						.calendar('setting', 'maxDate', this.getMaxDate())
						.calendar('refresh');
				}
			},
			onChange: (date: Date | null) => {
				if (settings.type == 'date') {
					date?.setHours(0, 0, 0, 0);
				}

				this.value = date;
				this.valueChange.emit(date);
			},
			onHidden: () => {
				if (this.getMinDate()) {
					this.jQueryElement
						.calendar('setting', 'minDate', null)
						.calendar('refresh');
				}

				if (this.getMaxDate()) {
					this.jQueryElement
						.calendar('setting', 'maxDate', null)
						.calendar('refresh');
				}
			}
		}, this.settings);

		this.minDate = settings.minDate;
		delete settings.minDate;

		this.maxDate = settings.maxDate;
		delete settings.maxDate;

		setTimeout(() => {
			this.jQueryElement = $(this.elementRef.nativeElement).calendar(settings);
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!this.jQueryElement) {
			this.ngAfterViewInit();
		} else {
			if (valueHasChanged(changes['value'])) {
				setTimeout(() => this.jQueryElement.calendar('set date', this.value, true, false));
			}
		}
	}

	ngOnDestroy(): void {
		this.jQueryElement?.calendar('destroy');
	}

	private getMinDate(): Date | null {
		const date = this.minValue ?? this.minDate;

		if (this.minDate && date && this.minDate > date) {
			return this.minDate;
		}

		return date;
	}

	private getMaxDate(): Date | null {
		const date = this.maxValue ?? this.maxDate;

		return date;
	}
}